import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import { useRemScale } from 'lib/remScale';
import { TYPE, FONTS } from 'style/typography';

/**
 * The guided step's one line of coaching, under the top bar. A keyboard step shows the key to press as a key cap
 * (owner 2026-10-09: keyboard steps say "press on your keyboard"; only click steps get the hand). Only its own
 * controls take clicks: the suggestion chips and a quiet "Skip tour" that ends the visit from any step (Sol
 * tour-dead-ends B: kept visually secondary so it is an escape, not an invitation; Help > Replay tour brings it back).
 */
export default function CoachCard({ text, keyCap, top, children, onSkip }) {
  const { rem } = useRemScale();
  if (!text && !children) return null;
  return (
    <View pointerEvents="box-none" style={[styles.wrap, { top: top || rem(84) }]} testID="first-visit-coach">
      <View pointerEvents="box-none" style={[styles.card, { borderRadius: rem(16), paddingVertical: rem(12), paddingHorizontal: rem(18), maxWidth: rem(560) }]}>
        <View style={styles.row} pointerEvents="none">
          {keyCap ? (
            <View style={[styles.key, { borderRadius: rem(8), minWidth: rem(40), height: rem(40), paddingHorizontal: rem(10), marginRight: rem(12) }]}>
              <Text style={[styles.keyText, { fontSize: rem(TYPE.lg), fontFamily: FONTS.heading }]}>{keyCap}</Text>
            </View>
          ) : null}
          {text ? (
            <Text style={[styles.text, { fontSize: rem(TYPE.lg), fontFamily: FONTS.heading }]}>{text}</Text>
          ) : null}
        </View>
        {children}
        {onSkip ? (
          <TouchableOpacity
            testID="first-visit-skip"
            accessibilityRole="button"
            accessibilityLabel="Skip tour"
            onPress={onSkip}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
            style={[styles.skip, { marginTop: rem(6) }]}>
            <Text style={[styles.skipText, { fontSize: rem(TYPE.xs), fontFamily: FONTS.body }]}>Skip tour</Text>
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { position: 'absolute', left: 0, right: 0, alignItems: 'center', zIndex: 94 },
  card: {
    backgroundColor: 'rgba(15,16,20,0.92)',
    borderWidth: 1,
    borderColor: 'rgba(197,232,54,0.35)',
    shadowColor: '#000',
    shadowOpacity: 0.45,
    shadowRadius: 20,
    shadowOffset: { width: 0, height: 10 },
  },
  row: { flexDirection: 'row', alignItems: 'center' },
  key: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#C5E836',
    borderBottomWidth: 3,
    borderBottomColor: '#7E9A1F',
  },
  keyText: { color: '#10120A', fontWeight: '800' },
  text: { color: '#F6FBFF', fontWeight: '600', flexShrink: 1 },
  skip: { alignSelf: 'flex-end' },
  skipText: { color: 'rgba(246,251,255,0.55)', textDecorationLine: 'underline' },
});
